import React from "react";
import { Box, Heading } from "@chakra-ui/react";

type VotingViewTileProps = {
  title: string;
  children: React.ReactNode;
};

export const VotingViewTile: React.FC<VotingViewTileProps> = ({ title, children }) => (
  <Box w="100%" bg="white" borderRadius="20px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 6px 20px rgba(67,0,152,0.05)" p={{ base: "22px", md: "28px" }}>
    <Heading fontSize={{ base: "17px", md: "19px" }} fontWeight="800" color="primary" mb="16px">
      {title}
    </Heading>
    {children}
  </Box>
);
